module.exports = __webpack_public_path__ + "static/media/SF-1.b2be0a3d.mp3";